import { DocumentIsogd } from "isogd-document-rest";

class DocumentLinkViewController {
    private document: DocumentIsogd;
}

export const DocumentLinkViewComponent: angular.IComponentOptions = {
    controller: DocumentLinkViewController,
    template: require('./documentLinkView.html'),
    bindings: {
        document: "<"
    }
};


// WEBPACK FOOTER //
// ./src/components/document/document-link/documentLinkView.ts